import { useState } from 'react'
import { Headphones } from 'lucide-react'
import { SubscribeDialog } from './subscribe-dialog'

interface SeriesRssButtonProps {
  seriesId: string
}

export function SeriesRssButton({ seriesId }: SeriesRssButtonProps) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-full border border-black/10 bg-white px-4 py-2 text-sm font-medium text-foreground shadow-sm transition-all hover:bg-black/5"
        title="Listen & Subscribe"
      >
        <Headphones className="h-4 w-4" />
        <span>Listen</span>
      </button>

      {open && (
        <SubscribeDialog open={open} onOpenChange={setOpen} seriesId={seriesId} />
      )}
    </>
  )
}
